export default __webpack_public_path__ + "static/media/scrolls-api-paths.d98a5c99.svg";